// src/pages/Categories/CategoriesPage.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Spin, List, Card, Typography, Space, Tag, Tabs } from "antd";
import { CalendarOutlined, UserOutlined } from "@ant-design/icons";
import BlogLayout from "../../components/BlogLayout";
import { useAuth, useTags, usePosts } from "../../hooks/useBlogAPI";
import "./CategoriesPage.css";

const { Title } = Typography;
const { TabPane } = Tabs;

const CategoriesPage = () => {
  const [activeTag, setActiveTag] = useState("");
  const { user } = useAuth();
  const navigate = useNavigate();
  const { data: tags, loading: tagsLoading } = useTags();
  const { data: posts, loading: postsLoading } = usePosts(1, 100, {
    tag: activeTag,
  });

  // 默认激活第一个标签
  useEffect(() => {
    if (tags && tags.length > 0 && !activeTag) {
      setActiveTag(tags[0].name);
    }
  }, [tags, activeTag]);

  const handleTabChange = (tag) => {
    setActiveTag(tag);
  };

  const renderPosts = () => {
    if (postsLoading) {
      return <Spin />;
    }

    if (!posts || posts.length === 0) {
      return <p>该标签下暂无文章</p>;
    }

    return (
      <List
        itemLayout="vertical"
        size="large"
        dataSource={posts}
        renderItem={(article) => (
          <List.Item key={article.id}>
            <List.Item.Meta
              title={
                <Typography.Link
                  onClick={() => navigate(`/posts/${article.id}`)}
                  style={{ fontSize: "1.2em" }}
                >
                  {article.title}
                </Typography.Link>
              }
              description={
                <Space size="middle">
                  <span>
                    <UserOutlined /> {article.author}
                  </span>
                  <span>
                    <CalendarOutlined />{" "}
                    {new Date(article.publishedDate).toLocaleDateString()}
                  </span>
                  {article.tags &&
                    article.tags.map((tag) => (
                      <Tag color="blue" key={tag}>
                        {tag}
                      </Tag>
                    ))}
                </Space>
              }
            />
            <div>
              {article.content.length > 200
                ? article.content.substring(0, 200) + "..."
                : article.content}
            </div>
          </List.Item>
        )}
      />
    );
  };

  return (
    <BlogLayout user={user}>
      <div className="container">
        <Card title={<Title level={2}>文章分类</Title>}>
          {tagsLoading ? (
            <Spin />
          ) : (
            <>
              <Tabs
                activeKey={activeTag}
                onChange={handleTabChange}
                tabPosition="top"
              >
                {tags &&
                  tags.map((tag) => (
                    <TabPane
                      tab={`${tag.name} (${tag.count})`}
                      key={tag.name}
                    />
                  ))}
              </Tabs>

              <div className="posts-content">{renderPosts()}</div>
            </>
          )}
        </Card>
      </div>
    </BlogLayout>
  );
};

export default CategoriesPage;
